module.exports = __webpack_public_path__ + "static/media/湖北中医药大学_x264.2ffa698.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/湖北中医药大学_x264.mp4
// module id = 8Gss
// module chunks = 13